"use client";

import { ProductTile } from "@/components/productTile/productTile.component";
import { ProductTileQuantityStepper } from "@/components/productTile/productTileQuantityStepper.component";
import { Text } from "@/components/text/text.component";

import { addAccessoryToConfigurator } from "@/app/blu/shop/[slug]/actions";
import { type CategoryProducts } from "@/app/blu/shop/actions";
import { useConfiguratorInteractionEvent } from "@/hooks/useConfiguratorInteractionEvent";
import { GetConfiguratorQueryResult } from "@/sanity.types";

export const ConfiguratorAccessoriesProducts = ({
  kit,
  products,
  basketItems = {},
  pending,
}: ConfiguratorAccessoriesProductsProps) => {
  const fireConfiguratorEvent = useConfiguratorInteractionEvent();
  if (!products?.length) return null;
  const renderProducts = () => {
    if (pending) {
      return [...Array(3)].map((_, index) => (
        <li
          data-testid="configurator-accessories-products-list-loading-item"
          key={index}>
          <ProductTile loading product={{ slug: "/shop/product-slug" }} />
        </li>
      ));
    }
    return products.map((product, index) => {
      const isIncluded = kit?.bundledProducts?.find((bundledProduct) => {
        return bundledProduct?.product?.id == product?.id;
      });
      return (
        <li
          data-testid="configurator-accessories-products-list-item"
          key={product?.id || `accessory-${index}`}>
          <ProductTile product={product} viewDetails>
            <div className="flex flex-col gap-2 py-4 md:flex-row md:items-center md:gap-4">
              <ProductTileQuantityStepper
                basketItems={basketItems}
                id={product?.id}
                formAction={addAccessoryToConfigurator}
                onInteraction={(action) =>
                  fireConfiguratorEvent(action, product?.name)
                }
              />
              {isIncluded ? (
                <Text>{isIncluded.quantity ?? 1} included</Text>
              ) : null}
            </div>
          </ProductTile>
        </li>
      );
    });
  };
  return (
    <section data-testid="configurator-accessories-products">
      <ul
        data-testid="configurator-accessories-products-list"
        className="grid grid-cols-2 gap-6 xl:grid-cols-3">
        {renderProducts()}
      </ul>
    </section>
  );
};

export type ConfiguratorAccessoriesProductsProps = {
  kit?: NonNullable<GetConfiguratorQueryResult>["product"];
  products?: CategoryProducts;
  basketItems?: Record<string, number>;
  pending: boolean;
};
